import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const SafeMailingListsOption: LazyOption = createLazyOption(
    {
        key: 'safeMailingLists',
        titleStringKey: 'optionTitle_safeMailingLists',
        searchTermsStringKey: 'optionTitle_safeMailingLists',
        allowedOptionKeys: ['SafeRecipientsList'],
        isHidden: () => {
            return isFeatureEnabled('tri-spamV2SenderDomain') || IsShadowMailboxUser();
        },
    },
    lazyFullModule,
    m => m.default
);
export default SafeMailingListsOption;
